import script from "./FinanceView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceView.vue?vue&type=script&setup=true&lang=js"

import "./FinanceView.vue?vue&type=style&index=0&id=20aaac42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20aaac42"]])

export default __exports__